<template>

    <div id="recap" class="wrap">

        <!-- NATURE -->
        <ul class="natures">

            <li class="floating" v-if="fibsdd.natures.contractuel !== null">
                <p>INTERVENTION CONTRACTUELLE :</p>
                <p>{{ fibsdd.natures.contractuel === true ? 'oui' : 'non' }}</p>
                <div class="clear"></div>
            </li>
            <li v-if="fibsdd.natures.description">
                <p>DESCRIPTIF DEMANDE :</p>
                <pre id="desc-demande">{{ fibsdd.natures.description }}</pre>
            </li>

            <p>NATURE(S) DE L'INTERVENTION</p>

            <li v-if="fibsdd.natures.assemblage"><p>Assemblage de l'équipement</p></li>
            <li v-if="fibsdd.natures.miseEnService"><p>Mise en service de l'équipement</p></li>
            <li v-if="fibsdd.natures.modification"><p>Modification de l'équipement</p></li>
            <li v-if="fibsdd.natures.maintenance"><p>Maintenance de l'équipement</p></li>
            <li v-if="fibsdd.natures.controlePeriodique"><p>Contrôle d'étanchéité périodique</p></li>
            <li v-if="fibsdd.natures.controleNonPeriodique"><p>Contrôle d'étanchéité non périodique</p></li>
            <li v-if="fibsdd.natures.demantelement"><p>Démantèlement</p></li>
            <li v-if="fibsdd.natures.retrofit"><p>Rétrofit {{ retrait }} => {{ ajout }}</p></li>
            <li><p>{{ fibsdd.natures.autres }}</p></li>
            <li>
                <pre v-if="fibsdd.natures.observations !== '' && fibsdd.natures.observations !== null" id="observ-nature">{{ fibsdd.natures.observations }}</pre>
            </li>
        </ul>

        <!-- FUITES -->
        <ul class="fuites" v-if="fibsdd.natures.controlePeriodique || fibsdd.natures.controleNonPeriodique">
            <p v-if="fibsdd.ctrlEtanch.no_fuites === true">AUCUNE FUITE CONSTATÉE</p>

            <div v-else>
                <p>FUITES(S) CONSTATÉE(S)</p>

                <li v-for="fuite in fuites" :key="fuite.id">
                    <p>Fuite {{ fuite.order }} ({{ fuite.localisation }}) : réparation {{ (fuite.reparation) ? 'réalisée' : 'à faire' }}</p>
                </li>
            </div>
        </ul>

        <!-- MANIP -->
        <ul class="manips" v-if="fibsdd.operations.length > 0">
            <p>MANIPULATION(S) DE FLUIDE</p>

            <li v-for="op in fibsdd.operations" :key="op.id">
                <p>{{ op.type }} : {{ op.quantite }}Kg - {{ ( op.type.indexOf('Retrait') === -1 ) ? ajout : retrait }}</p>
            </li>
        </ul>

        <!-- RESUME -->
        <ul class="resume">
            <p>INFORMATIONS SUR L'INTERVENTION</p>

            <li class="floating" v-if="fibsdd.technicien">
                <p>TECHNICIEN</p>
                <p>
                    <strong id="resume-user" v-if="fibsdd.technicien.nom">
                        {{ fibsdd.technicien.last_name.toUpperCase() }} {{ fibsdd.technicien.first_name }}
                    </strong>
                </p>
                <div class="clear"></div>
            </li>

            <li class="floating" v-if="fibsdd.informations.temps_deplacement">
                <p>DÉPLACEMENT :</p>
                <p id="resume-duree-dep">{{ fibsdd.informations.temps_deplacement }}</p>
                <div class="clear"></div>
            </li>

            <li class="floating" v-if="fibsdd.informations.kilometrage">
                <p>KILOMÉTRAGE :</p>
                <p id="resume-kilometrage">{{ fibsdd.informations.kilometrage }}</p>
                <div class="clear"></div>
            </li>

            <li class="floating" v-if="fibsdd.informations.temps_intervention">
                <p>DURÉE DE L'INTERVENTION :</p>
                <p id="resume-duree-inter">{{ fibsdd.informations.temps_intervention }}</p>
                <div class="clear"></div>
            </li>

            <li class="floating" v-if="fibsdd.informations.heure_arrivee">
                <p>HEURE D'ARRIVÉE :</p>
                <p id="resume-heure-arrivee">{{ fibsdd.informations.heure_arrivee }}</p>
                <div class="clear"></div>
            </li>

            <li class="floating" v-if="fibsdd.informations.heure_depart">
                <p>HEURE DE DÉPART :</p>
                <p id="resume-heure-depart">{{ fibsdd.informations.heure_depart }}</p>
                <div class="clear"></div>
            </li>

            <li class="floating" v-if="fibsdd.informations.techs">
                <p>NOMBRE DE TECHNICIENS :</p>
                <p id="resume-techs">{{ fibsdd.informations.techs }}</p>
                <div class="clear"></div>
            </li>

            <li v-if="fibsdd.informations.namesTechniciens">
                <p>NOMS DES TECHNICIENS :</p>
                <pre id="resume-names-techs">{{ fibsdd.informations.namesTechniciens }}</pre>
                <div class="clear"></div>
            </li>

            <div v-if="fibsdd.informations.preventif ||
                       fibsdd.informations.correctif ||
                       fibsdd.informations.fromDevis ||
                       fibsdd.informations.garantie ||
                       fibsdd.informations.finish ||
                       fibsdd.informations.needDevis">
                <p>TYPE D'INTERVENTION :</p>

                <li v-if="fibsdd.informations.preventif">
                    <p>PREVENTIF (visite d'entretien)</p>
                </li>
                <li v-if="fibsdd.informations.correctif">
                    <p>CORRECTIF (dépannage)</p>
                </li>
                <li v-if="fibsdd.informations.fromDevis">
                    <p>INTERVENTION SELON DEVIS</p>
                </li>
                <li v-if="fibsdd.informations.garantie">
                    <p>INSTALLATION SOUS GARANTIE</p>
                </li>
                <li v-if="fibsdd.informations.finish">
                    <p>TRAVAUX TERMINÉS</p>
                </li>
                <li v-if="fibsdd.informations.needDevis">
                    <p>DEVIS À RÉALISER</p>
                </li>
            </div>

            <li v-if="fibsdd.informations.travauxEffectues">
                <p>TRAVAUX EFFECTUÉS :</p>
                <pre id="resume-travaux">{{ fibsdd.informations.travauxEffectues }}</pre>
                <div class="clear"></div>
            </li>

            <li v-if="fibsdd.informations.observations">
                <p>OBSERVATIONS :</p>
                <pre id="resume-observ">{{ fibsdd.informations.observations }}</pre>
            </li>
        </ul>

        <ul class="pieces" v-if="fibsdd.pieces.length > 0">
            <p>FOURNITURES</p>
            <li v-for="p in fibsdd.pieces" :key="p.id">
                <p>{{ p.designation | upperCase }} : {{ p.etat }} {{ p.qte }} <span v-if="p.prix">x {{ p.prix }}€</span></p>
            </li>
        </ul>

        <p id="cgv">
            Le client soussigné reconnait l'exactitude des travaux, fournitures, frais de déplacement, temps d'intervention et s'engage à en solder le montant à "{{ operateur }}".
            Clause de réserve de propriété en application de la loi n°80335 du 12.05.80, les marchandises livrées restent la propriété du vendeur jusqu'au paiement intégral de leur prix.
            Vous avez pris connaissance de nos C G V et les acceptez.
        </p>
    </div>

</template>

<script>
    import Installation from '../../../../js/models/Installation'
    import Fluide from '../../../../js/models/Fluide'


    export default {
        data(){
            return {
                ajout: "",
                retrait: "",
                operateur: ''
            }
        },
        props: {
            fibsdd: {},
            fuites: {
                type: Array,
                default: []
            }
        },
        methods: {
            // TODO : NE FONCTIONNE PAS
            fetchFluides(){
                if(this.fibsdd.installation) {

                    Installation
                        .getInstallation(this.fibsdd.installation)
                        .then(install => {

                            if(install.fluide !== null) {
                                this.retrait = install.fluide.nom;

                                if (this.fibsdd.natures.newFluide !== null && this.fibsdd.natures.retrofit === true) {

                                    let fluideObj = new Fluide;
                                    fluideObj
                                        .getFluide(this.fibsdd.natures.newFluide, fluide => {
                                            this.ajout = fluide.nom
                                        })

                                } else {

                                    this.ajout = install.fluide.nom

                                }
                            }

                        })
                        .catch()
                }
            },
            fetchOperatorName(){
                localforage.getItem('profil').then( usr => {
                    usr = JSON.parse(usr);
                    this.operateur = usr.operator.company
                })
            }
        },
        mounted(){
          this.fetchOperatorName()
        },
        updated(){
            this.fetchFluides()
        },
        filters: {
            upperCase(val){
                return val.toUpperCase()
            }
        }
    }

</script>

<style>

    #cgv {
        font-size: 11px;
        font-style: italic;
        color: #3f3f3f;
        margin-bottom: 25px;
    }

    #recap > ul > p, #recap > ul > div > p  {
        margin-bottom: 10px;
    }

    #finish #recap ul {
        border-top: 1px solid #999;
        padding: 10px 0;
    }

    #finish #recap ul:last-child {
        border-bottom: 1px solid #999;
        margin-bottom: 20px;
    }

    #finish #recap ul li {
        margin-bottom: 10px;
    }

    #finish #recap ul li.floating p {
        width: 50%;
        float: left;
    }

    #finish #recap ul li p {
        color: #666666;
        font-size: 1.2rem;
        font-weight: 400;
    }

    #finish #recap ul li strong {
        color: #000000;
        font-size: 1.5rem;
        font-weight: 700;
    }

    li > pre{
        background-color: #f1f1f1;
        border-radius: 6px;
        padding: 10px;
        color: #666666;
        font-size: 1.2rem;
        font-weight: 400;
        margin-top: 5px;
    }

</style>



// WEBPACK FOOTER //
// Recap.vue?0426683a